import React from 'react';
import { BaseSection } from './BaseSection';
import { QuantityAvailable } from './quantity-available/index';
import { ProductDescription } from './product-description/index';
import { ImportantRemark } from './important-remark/index';
import { Workmanship } from './workmanship/index';
import { PackingMarking } from './packing-marking/index';
import { OnsiteChecking } from './onsite-checking/index';

const SECTION_PROVIDER = {
  quantityAvailable: QuantityAvailable,
  productDescriptionStyleColor: ProductDescription,
  workmanship: Workmanship,
  packingMarking: PackingMarking,
  onSiteTest: OnsiteChecking,
  importantRemarksAttachments: ImportantRemark,
};

export const Section = ({ section, ordinal }) => {
  const [open, setOpen] = React.useState(false);
  const { configs, value, fields, enabled } = section;

  const ModalForm = React.useMemo(() => {
    const SectionComponent = SECTION_PROVIDER[section.name];
    return SectionComponent;
  }, [section, open]);

  return (
    <>
      <BaseSection
        name={value}
        ordinal={ordinal}
        enabled={enabled}
        contentField={fields.length}
        onView={() => {
          setOpen(true);
        }}
      />
      {!open ? null : (
        <ModalForm
          open={open}
          fields={fields}
          configs={configs}
          sectionLabel={section.value}
          onCancel={() => {
            setOpen(false);
          }}
        />
      )}
    </>
  );
};
